import { render, staticRenderFns } from "./ContentName.vue?vue&type=template&id=4541a331&"
import script from "./ContentName.vue?vue&type=script&lang=js&"
export * from "./ContentName.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports